import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
    <SEOHead
      title="Page Not Found | Milky Way Planner"
      description="The page you're looking for doesn't exist. Return to Milky Way Planner to plan your next astrophotography session."
      noindex
    />
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
          <a href="/" className="text-gold-dark hover:text-gold underline">
            Return to Home
          </a>
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
};

export default NotFound;
